<template lang="pug">
section(:class='alertaLaudos ? "home-usuario-is-laudo" : "home"')
    AlertaUsuaioLaudos(:alertaLaudos='alertaLaudos', @closeAlerta='closeAlerta()')

    section.home__pesquisa-inteligente
        PesquisaInteligente

    section.home__noticias
        BannerNoticias

    section.home__central-alertas
        CentralAlerta

    section.home__acesso-rapido
        AcessoRapido

    section.home__totalizadores
        Totalizadores

    section.home__central-eventos
        CentralEventos
</template>

<script>
import Totalizadores from '@/components/home/Totalizadores';
import CentralAlerta from '@/components/home/CentralAlerta';
import PesquisaInteligente from '@/components/home/PesquisaInteligente.vue';
import CentralEventos from '@/components/home/CentralEventos.vue';
import BannerNoticias from '@/components/home/BannerNoticias.vue';
import AcessoRapido from '@/components/home/acessoRapido/AcessoRapido';
import AlertaUsuaioLaudos from '@/components/home/AlertaUsuaioLaudos.vue';

import { mapState } from 'vuex';

export default {
    name: 'index',

    components: {
        AcessoRapido,
        PesquisaInteligente,
        CentralAlerta,
        Totalizadores,
        CentralEventos,
        BannerNoticias,
        AlertaUsuaioLaudos
    },

    data() {
        return {
            alertaLaudos: false
        };
    },

    computed: {
        ...mapState(['usuarioIsLaudo'])
    },

    created() {
        this.alertaLaudos = !!this.usuarioIsLaudo;
    },

    watch: {
        usuarioIsLaudo(newValue) {
            if (this.alertaLaudos !== newValue) {
                this.alertaLaudos = !!this.usuarioIsLaudo;
            }
        }
    },

    methods: {
        closeAlerta() {
            this.alertaLaudos = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.home {
    padding: 20px;
    height: 100%;
    display: grid;
    gap: 12px;
    grid-template:
        'pesquisa-inteligente pesquisa-inteligente' 50px
        'noticias central-alertas' 200px
        'acesso-rapido central-eventos' 140px
        'totalizadores central-eventos' 1fr/2fr 1fr;
}

.home-usuario-is-laudo {
    padding: 20px;
    height: 100%;
    display: grid;
    gap: 12px;
    grid-template:
        'alerta-usuario-laudos alerta-usuario-laudos' 50px
        'pesquisa-inteligente pesquisa-inteligente' 50px
        'noticias central-alertas' 200px
        'acesso-rapido central-eventos' 140px
        'totalizadores central-eventos' 1fr/2fr 1fr;
}

 .alerta-usuario-laudos {
     grid-area: alerta-usuario-laudos;
}

.home__pesquisa-inteligente {
    grid-area: pesquisa-inteligente;
}

.home__noticias {
    grid-area: noticias;
    padding-bottom: 30px;
}

.home__central-alertas {
    grid-area: central-alertas;
    padding-bottom: 30px;
}

.home__acesso-rapido {
    grid-area: acesso-rapido;
    overflow-x: auto;
    overflow-y: hidden;
}

.home__totalizadores {
    padding-bottom: 10px;
    grid-area: totalizadores;
}

.home__central-eventos {
    padding-bottom: 10px;
    grid-area: central-eventos;
}
</style>
